export default "__VITE_ASSET__g7F6r0_F__"